import React from 'react';
import { useRecipesByTag } from 'hooks/data/useRecipesByTag';
import classnames from 'classnames';

import { Error, Skeleton } from 'components/ui';
import { APP_ROUTES } from 'constants/routes';

import RecipesListingTemplate from '../RecipesListingTemplate/RecipesListingTemplate';

import type {
  IRecipesByTagPageUrlParams
} from 'types';

import styles from './RecipesByTagTemplate.module.scss';

const BREADCRUMBS = [
  {
    href: APP_ROUTES.HOME,
    name: 'NAVIGATION.HOME',
    translate: true
  },
  {
    href: APP_ROUTES.RECIPES_LANDING,
    name: 'NAVIGATION.BLOG.RECIPES.DEFAULT',
    translate: true
  },
];

interface Props {
  className?: string,
  preview: boolean,
  urlParams: IRecipesByTagPageUrlParams
}

const RecipesByTagTemplate = (props: Props) => {

  const {
    className,
    urlParams,
    preview
  } = props;

  const {
    data, isError, isLoading
  } = useRecipesByTag({ ...urlParams, preview });

  // Props

  if (isError) {
    return (
      <Error />
    );
  }

  if (isLoading) {
    return <Skeleton count={3} />;
  }

  // Render

  if (data) {
    const {
      details,
      banner,
      recipes,
      pagination,
    } = data;

    const {
      title
    } = details || {};
    return (
      <RecipesListingTemplate
        className={classnames(styles.root, className)}
        //
        breadcrumbs={[
          ...BREADCRUMBS,
          {
            name: title,
            translate: false,
          }
        ]}
        //
        title={!banner ? title : undefined}
        banner={banner}
        //
        recipes={recipes}
        pagination={pagination}
        //
        urlParams={urlParams}
      />
    );
  }

  return null;
};

export default RecipesByTagTemplate;
